module.exports = __webpack_public_path__ + "media/Corn_Crake.b1bd06f7.mp3";